import type { RouteObject } from "react-router";
import { Navigate } from "react-router";
import { Component } from "./utils";

export const frontendDashboardRoutes: RouteObject[] = [
	{ path: "workbench", element: Component("/pages/dashboard/workbench") },
	{ path: "analysis", element: Component("/pages/dashboard/analysis") },
	{
		path: "components",
		children: [
			{ index: true, element: <Navigate to="animate" replace /> },
			{ path: "animate", element: Component("/pages/components/animate") },
			{ path: "scroll", element: Component("/pages/components/scroll") },
			{
				path: "multi-language",
				element: Component("/pages/components/multi-language"),
			},
			{ path: "icon", element: Component("/pages/components/icon") },
			{ path: "upload", element: Component("/pages/components/upload") },
			{ path: "chart", element: Component("/pages/components/chart") },
			{ path: "toast", element: Component("/pages/components/toast") },
		],
	},
	{
		path: "functions",
		children: [
			{ index: true, element: <Navigate to="clipboard" replace /> },
			{ path: "clipboard", element: Component("/pages/functions/clipboard") },
			{
				path: "token_expired",
				element: Component("/pages/functions/token-expired"),
			},
		],
	},
	{
		path: "management",
		children: [
			{ index: true, element: <Navigate to="user" replace /> },
			{ path: "feedback", element: Component("/pages/management/feedback") },
			{ path: "email", element: Component("/pages/management/email") },
			{
				path: "email/:thread_uuid",
				element: Component("/pages/management/email/thread"),
			},
			{
				path: "user",
				children: [
					{ index: true, element: <Navigate to="profile" replace /> },
					{
						path: "profile",
						element: Component("/pages/management/user/profile"),
					},
					{
						path: "account",
						element: Component("/pages/management/user/account"),
					},
				],
			},
			{
				path: "system",
				children: [
					{ index: true, element: <Navigate to="permission" replace /> },
					{
						path: "permission",
						element: Component("/pages/management/system/permission"),
					},
					{ path: "role", element: Component("/pages/management/system/role") },
					{ path: "user", element: Component("/pages/management/system/user") },
					{
						path: "user/:id",
						element: Component("/pages/management/system/user/detail"),
					},
				],
			},
		],
	},
	{
		path: "error",
		children: [
			{ index: true, element: <Navigate to="403" replace /> },
			{ path: "403", element: Component("/pages/sys/error/Page403") },
			{ path: "404", element: Component("/pages/sys/error/Page404") },
			{ path: "500", element: Component("/pages/sys/error/Page500") },
		],
	},
	{
		path: "menu_level",
		children: [
			{ index: true, element: <Navigate to="1a" replace /> },
			{ path: "1a", element: Component("/pages/menu-level/menu-level-1a") },
			{
				path: "1b",
				children: [
					{ index: true, element: <Navigate to="2a" replace /> },
					{
						path: "2a",
						element: Component("/pages/menu-level/menu-level-1b/menu-level-2a"),
					},
					{
						path: "2b",
						children: [
							{ index: true, element: <Navigate to="3a" replace /> },
							{
								path: "3a",
								element: Component("/pages/menu-level/menu-level-1b/menu-level-2b/menu-level-3a"),
							},
							{
								path: "3b",
								element: Component("/pages/menu-level/menu-level-1b/menu-level-2b/menu-level-3b"),
							},
						],
					},
				],
			},
		],
	},
	{
		path: "link",
		children: [
			{ index: true, element: <Navigate to="iframe" replace /> },
			{
				path: "iframe",
				element: Component("/pages/sys/others/link/iframe", {
					src: "https://ant.design/index-cn",
				}),
			},
			{
				path: "external-link",
				element: Component("/pages/sys/others/link/external-link", {
					src: "https://ant.design/index-cn",
				}),
			},
		],
	},
	{
		path: "permission",
		children: [
			{ index: true, element: Component("/pages/sys/others/permission") },
			{
				path: "page-test",
				element: Component("/pages/sys/others/permission/page-test"),
			},
		],
	},
	{ path: "calendar", element: Component("/pages/sys/others/calendar") },
	{ path: "kanban", element: Component("/pages/sys/others/kanban") },
	{ path: "blank", element: Component("/pages/sys/others/blank") },
	{
		path: "users",
		element: Component("/pages/management/user"),
	},
	{
		path: "users/:id",
		element: Component("/pages/management/user/detail"),
	},
	{
		path: "user-scrapes",
		element: Component("/pages/management/user-scrapes"),
	},
	{
		path: "user-scrapes/:id",
		element: Component("/pages/management/user-scrapes/detail"),
	},
	{
		path: "feedbacks",
		element: Component("/pages/management/feedback"),
	},
	{
		path: "feedbacks/:id",
		element: Component("/pages/management/feedback/detail"),
	},
	{
		path: "emails",
		element: Component("/pages/management/email"),
	},
	{
		path: "emails/:thread_uuid",
		element: Component("/pages/management/email/thread"),
	},
	{
		path: "unlockables",
		element: Component("/pages/management/unlockables"),
	},
	{
		path: "unlockables/create",
		element: Component("/pages/management/unlockables/create"),
	},
	{
		path: "unlockables/:id",
		element: Component("/pages/management/unlockables/detail"),
	},
	{
		path: "unlockable-discounts",
		element: Component("/pages/management/unlockable-discounts"),
	},
	{
		path: "agentic",
		element: Component("/pages/management/agentic"),
	},
	{
		path: "agentic/tasks/:id",
		element: Component("/pages/management/agentic/tasks/detail"),
	},
	{
		path: "unlockable-discounts/create",
		element: Component("/pages/management/unlockable-discounts/create"),
	},
	{
		path: "unlockable-discounts/:id",
		element: Component("/pages/management/unlockable-discounts/detail"),
	},
	{
		path: "token-grant-codes",
		element: Component("/pages/management/token-grant-codes"),
	},
	{
		path: "token-grant-codes/create",
		element: Component("/pages/management/token-grant-codes/create"),
	},
	{
		path: "token-grant-codes/:id",
		element: Component("/pages/management/token-grant-codes/detail"),
	},
	{
		path: "advertisement-request-status-timings",
		element: Component("/pages/management/advertisement-request-status-timings"),
	},
	{
		path: "advertisement-request-status-timings/detail",
		element: Component("/pages/management/advertisement-request-status-timings/detail"),
	},
	{
		path: "economics",
		element: Component("/pages/management/economics"),
	},
	{
		path: "economics/:id",
		element: Component("/pages/management/economics/detail"),
	},
	{
		path: "token-packages",
		element: Component("/pages/management/token-packages"),
	},
	{
		path: "token-packages/create",
		element: Component("/pages/management/token-packages/create"),
	},
	{
		path: "token-packages/:id",
		element: Component("/pages/management/token-packages/detail"),
	},
	{
		path: "advertisement-request-queues",
		element: Component("/pages/management/advertisement-request-queues"),
	},
	{
		path: "advertisement-requests",
		element: Component("/pages/management/advertisement-requests"),
	},
	{
		path: "advertisement-requests/:id",
		element: Component("/pages/management/advertisement-requests/detail"),
	},
	{
		path: "external-reports",
		element: Component("/pages/management/external-reports"),
	},
	{
		path: "external-reports/:id",
		element: Component("/pages/management/external-reports/detail"),
	},
	{
		path: "ai-generations",
		element: Component("/pages/management/ai-generations"),
	},
	{ path: "404", element: Component("/pages/sys/error/Page404") },
];
